import { useEffect, useState } from 'react';

import MoreVertIcon from '@mui/icons-material/MoreVert';
import { IconButton, ListItemText, Menu, MenuItem } from '@mui/material';

import { DECOMPOSITION_TREE_TEST_ID } from '../testIds';
import type { ItemCallbacks } from '../types';

export const NodeActionMenu = ({
  nodeId,
  dataNodeId,
  cb,
  nodeName,
  onOpenChange
}: {
  nodeId: string;
  dataNodeId: string;
  cb: ItemCallbacks;
  nodeName: string;
  onOpenChange?: (open: boolean) => void;
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  useEffect(() => {
    onOpenChange?.(Boolean(anchorEl));
  }, [anchorEl, onOpenChange]);

  return (
    <>
      <IconButton
        size='small'
        tabIndex={0}
        aria-label='Node actions'
        data-testid={DECOMPOSITION_TREE_TEST_ID.nodeActionsButton(dataNodeId)}
        sx={{ p: 0.25, ml: 0.5 }}
        onClick={(e) => {
          e.stopPropagation();
          setAnchorEl(e.currentTarget);
        }}
      >
        <MoreVertIcon fontSize='small' />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        onClick={(e) => e.stopPropagation()}
        data-testid={DECOMPOSITION_TREE_TEST_ID.nodeActionsMenu(dataNodeId)}
        slotProps={{ paper: { sx: { minWidth: 160 } } }}
      >
        <MenuItem
          data-testid={DECOMPOSITION_TREE_TEST_ID.nodeActionOpenDetails}
          onClick={() => {
            cb.onOpenDetails(nodeId);
            setAnchorEl(null);
          }}
        >
          <ListItemText>Open details</ListItemText>
        </MenuItem>

        <MenuItem
          data-testid={DECOMPOSITION_TREE_TEST_ID.nodeActionAddChild}
          onClick={() => {
            cb.onAddChild(nodeId);
            setAnchorEl(null);
          }}
        >
          <ListItemText>Add child {nodeName}</ListItemText>
        </MenuItem>

        <MenuItem
          data-testid={DECOMPOSITION_TREE_TEST_ID.nodeActionMove}
          onClick={() => {
            cb.onRequestMove(nodeId);
            setAnchorEl(null);
          }}
        >
          <ListItemText>Move {nodeName}</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
};
